export default V => [
  {
    path: '/sign-in',
    component: V('auth/Base'),
    children: [
      {
        name: 'auth.signIn',
        path: '',
        component: V('auth/SignIn'),
        meta: { title: 'Login', public: true },
      },
    ],
  },
]
